import { createRatesEnterpriseCityRequest } from "../../data/ratesEnterpriseCityApi";
import { validateTarifaEnterpriseCityPayload } from "../validator/validateTarifaEnterpriseCityPayload";

export async function createTarifaEnterpriseCityUseCase(payload) {
  const error = validateTarifaEnterpriseCityPayload(payload);

  if (error) {
    throw new Error(error);
  }

  return await createRatesEnterpriseCityRequest(payload);
}
